
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Logo from '@/shared/logo.vue';
import SectionPositionInfo from '../shared/interfaces';

@Component({
  components: {
    Logo,
  },
})
export default class SiteHeader extends Vue {
  @Prop() currentSection?: SectionPositionInfo;
  @Prop() scrollValue?: number;
  @Prop() isWorkDetailPage?: boolean;
  isScrollDirectionUp: boolean = true;

  navigateHome() {
    this.$router.push('/');
  }

  /*
   * Triggers the nav show/hide
   * Watches the scoll value property, the scrollTop value passed down from the
   * parent component.
   */
  @Watch('scrollValue')
  private onScrollValueChange(value: number, oldValue: number) {
    if (value > oldValue) {
      this.isScrollDirectionUp = false;
    } else {
      this.isScrollDirectionUp = true;
    }
  }
}
